import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { markPdfDataExtractionReportDownloaded } from '../../../api/pdfDataExtraction/pdfDataExtractionSlice';
import { apiClient } from '../../../utils/axios';

const DataExtractionUploadActionsMenu = ({ row }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadFile = async (downloadType) => {
    dispatch(showSnackbar({ message: 'Downloading...', severity: 'info' }));

    try {
      const response = await apiClient.get(`/pdf-data-extractions/${row?._id}/download`, {
        params: {
          downloadType: downloadType,
        },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.headers.get('x-suggested-filename'));
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      dispatch(markPdfDataExtractionReportDownloaded(true));
      handleClose();
    } catch (error) {
      dispatch(
        showSnackbar({
          open: true,
          message: `Error downloading the file: ${error.message}`,
          severity: 'error',
        }),
      );
      dispatch(markPdfDataExtractionReportDownloaded(false));
      handleClose();
    }
  };

  const actionsDisabled = row.status === 'uploaded' || row.status === 'processing';

  return (
    <>
      <IconButton id="action-icon-button" onClick={handleClick} disabled={actionsDisabled}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        {row.status === 'completed' && (
          <MenuItem id="excel-export" onClick={() => handleDownloadFile('export-excel')}>
            Excel Export
          </MenuItem>
        )}
        <MenuItem onClick={() => handleDownloadFile('original')}>Original File</MenuItem>
        <MenuItem onClick={() => handleDownloadFile('log')}>Logs</MenuItem>
      </Menu>
    </>
  );
};

export default DataExtractionUploadActionsMenu;
